import { AccessToken } from '../../../../access-token';
import { ApiCall } from '../../../../http-service/types/ApiCall';
import { SSOTokenData } from '../../../types/SSOTokenData';
import { UserImpersonation } from '../../../../user-impersonation';
import { B2CHttpService } from '../b2c-http-service';
import { B2CAuthTokenExchangeParams } from './types/B2CAuthTokenExchangeParams';
import { B2CRefreshTokenExchangeParams } from './types/B2CRefreshTokenExchangeParams';
import { B2C_SSO_POLICY } from './enums/b2c-sso-policy';

const getDefaultParams = () => {
  if (!process.env.AZURE_AD_B2C__FRONTEND_CLIENT_ID || !process.env.AZURE_AD_B2C__TENANT || !process.env.AZURE_AD_B2C__SCOPE) return null;
  return {
    client_id: process.env.AZURE_AD_B2C__FRONTEND_CLIENT_ID,
    scope: `openid profile offline_access https://${process.env.AZURE_AD_B2C__TENANT}.onmicrosoft.com/api/${process.env.AZURE_AD_B2C__SCOPE}.read https://${process.env.AZURE_AD_B2C__TENANT}.onmicrosoft.com/api/${process.env.AZURE_AD_B2C__SCOPE}.write`,
  };
};

type TokenExchangeParams = B2CAuthTokenExchangeParams | B2CRefreshTokenExchangeParams;

export const exchangeB2CToken: ApiCall<TokenExchangeParams, SSOTokenData> = async ({
  params,
  abortSignal,
}) => {
  const { data } = await B2CHttpService.post(
    `/${params.policy}/oauth2/v2.0/token`,
    {
      ...getDefaultParams(),
      ...params,
    },
    abortSignal
  );
  return data;
};

export const logoutB2C: ApiCall = async () => {
  await B2CHttpService.post(`/${B2C_SSO_POLICY.SIGN_IN}/oauth2/v2.0/logout`);
  AccessToken.clearTokens();
  UserImpersonation.clearImpersonationData();
};
